import React, { FC } from 'react';
import { SystemManager } from '../../../utils/SystemManager';

const Titular: FC = () => {
  return <>{SystemManager.getSystem('tarjeta-titular')}</>;
};

export default Titular;
